module.exports = __webpack_public_path__ + "static/img/pwa.ade53014.png";